module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAA9klEQVQokXXSIU/DQBgG4GelCILBw8+oIkgSzBRMkSARFcsIagK5MBSDhKxmCoUmMyRkcqr/gywIcAgaQHAN47J+5su93z2XS+5ag+liDw/YwkVVFjeiSrP8DAO84TjBFbaxiVGa5f0I9DEK8x1cJqiig4c1DH0YzT9bg+liF8/YiIZPOIiyD+wnVVnM0Q7Bcq0C7aos5glUZTFrgDGYQVKnIZg0oEkN/qE0y3N0G1A3zP9QCMYNoK5xmuWn0BpMFye4jzZ84hrnWF/Kv4THvV0BOlVZ9NEJ6+Wb3SX4XgEeIfQYriXo+f1TLzisQV1hfYRXvKP3AxZkWlLtY/KCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/closeDoctorFilter.png
// module id = 109
// module chunks = 0